import { Component, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { Control } from '../../../models/control';
import { EmailTemplate } from '../../../models/emailTemplate';
import {MatDialog as MatDialog, MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AddTemplateDialog } from './dialogs/add-template/add-template.dialog';
import { DeleteTemplateDialog } from './dialogs/delete-template/delete-template.dialog';
import { NotificationsTemplates } from 'src/services/api-services/api-interfaces/api.interface.notifications-templates';
import { APINotificationsTemplatesService } from 'src/services/api-services/api-notifications-templates';
import { HelperService } from 'src/services/helperService';
// import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ClassicEditor from 'ckeditor5-build-classic-plus';

import { finalize } from 'rxjs';

@Component({
    selector: 'app-templates',
    templateUrl: './templates.component.html',
    styleUrls: ['./templates.component.sass'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TemplatesComponent implements OnInit {
  emailTemplates: EmailTemplate[] = [
    {
      asunto:"Confirmación de cita",
      name: 'Confirmación de cita',
      type: 'SCHEDULED',
      content: '<h1>Confirmación de cita</h1>',
      datemodification:"",
      isActive : false,
    },
    {
      asunto:"Cancelación de cita",
      name: 'Cancelación de cita',
      type: 'CANCELATION',
      content: '<h1>Cancelación de citaaaaaaaaaaaaa</h1>',
      datemodification:"",
      isActive : false,
    },
    {
      asunto:"Re-agendamiento de cita",
      name: 'Re-agendamiento de cita',
      type: 'RE-SCHEDULE',
      content: '<h1>Re-agendamiento de cita</h1>',
      datemodification:"",
      isActive : false,
    }
  ];

  public Editor = ClassicEditor;


  configuration: any = {height: 700,fontSize: {options: [8,9,10,11,12,14,16,18,20,22, 24,26, 28,36]},toolbar: ['undo','redo', '|', 'bold','italic','underline', '|','link','|','alignment:left', 'alignment:center','alignment:right','alignment:justify','|','fontFamily','fontSize','fontColor','|','heading','heading1','heading2','heading3','|','image']};

  public editorsReady(editor) {
    editor.ui.getEditableElement().parentElement.insertBefore(
      editor.ui.view.toolbar.element,
      editor.ui.getEditableElement()
    );
  }
  selectedEmailTemplate: EmailTemplate = this.emailTemplates[0];
  selectedTemplateType: string = this.selectedEmailTemplate.type;
  subject: string = 'Asunto';
  messageDropdown: string = 'message';
  data_base:NotificationsTemplates [] = []
  constructor(public dialog: MatDialog, public notificationtemplateService : APINotificationsTemplatesService, public helperService: HelperService,) { }


getNotificationsTemplates() {
  let id = sessionStorage.getItem('templateId') || '';
  this.notificationtemplateService?.get(id).pipe(finalize( () =>  this.dataintworkshopName()))
  .subscribe({
    next: (response: any) => {
      this.data_base = response
    },
    error: (error) => {
      // Manejo de error 401
      if (error.status === 401) {
        this.helperService.logoutToken();
      }
    }
  })
}

dataintworkshopName()
{
 for(let i=0;i< this.data_base.length;i++){

     let Change_Date_format = this.data_base[i].lastModification.split("T")
     Change_Date_format = Change_Date_format[0].split('-')
     this.data_base[i].lastModification = Number(Change_Date_format[2])+"/"+Change_Date_format[1]+"/"+Change_Date_format[0]


 }
 this.Load_data()
}
  Load_data()

  {
    let template = this.data_base.filter(data => data.templateName   === "SCHEDULED")
    this.emailTemplates[0].content =  template.map(d=> d.templateBody)[0]
    this.emailTemplates[0].asunto =  template.map(d=> d.templateSubject)[0]
    this.emailTemplates[0].datemodification = template.map(d=> d.lastModification)[0]
    this.emailTemplates[0].isActive = template.map(d=> d.isPublish)[0]

    template = this.data_base.filter(data => data.templateName   === "CANCELATION")
    this.emailTemplates[1].content =  template.map(d=> d.templateBody)[0]
    this.emailTemplates[1].asunto =  template.map(d=> d.templateSubject)[0]
    this.emailTemplates[1].datemodification = template.map(d=> d.lastModification)[0]
    this.emailTemplates[1].isActive = template.map(d=> d.isPublish)[0]

    template = this.data_base.filter(data => data.templateName   === "RE-SCHEDULE")
    this.emailTemplates[2].content =  template.map(d=> d.templateBody)[0]
    this.emailTemplates[2].asunto =  template.map(d=> d.templateSubject)[0]
    this.emailTemplates[2].datemodification = template.map(d=> d.lastModification)[0]
    this.emailTemplates[2].isActive = template.map(d=> d.isPublish)[0]
  }

  ngOnInit(): void {
    this.getNotificationsTemplates()

  }

  onLockControlClick = (param: string): void => {

  }



  controls: Control[] = [
    {
      icon: 'bi bi-lock',
      description: 'Save',
      action: this.onLockControlClick
    }
  ];
  Datereal = new Date();
  showdata: boolean = true;
  reloadScheduler(show: boolean) {
    if (show) {
      setInterval(() => {
        this.showdata = true;
      }, 2000);
    } else
      this.showdata = false;

  }
  createInfo(){
    let datamodific =this.Datereal.getFullYear() +'-'+ (this.Datereal.getMonth()+1) +'-'+  this.Datereal.getDate()

    let template = this.data_base.filter(data => data.templateName   === this.selectedTemplateType)


    let dataInt ={
    templateId:      template.map(d=> d.templateId)[0],
    templateName:     this.selectedTemplateType,
    templateSubject:  this.selectedEmailTemplate.asunto,
    templateBody:     this.selectedEmailTemplate.content,
    lastModification: new Date(datamodific),
    isPublish:        this.selectedEmailTemplate.isActive,
    notificationtype: template.map(d=> d.notificationtype)[0]}

    this.reloadScheduler(false)

    this.notificationtemplateService.put(dataInt).pipe(finalize( () =>  {  this.ngOnInit()
      // MENSAJE
      this.reloadScheduler(true)
    })).subscribe();

  }


  setSelectedTemplate(event: any) {
    this.selectedEmailTemplate = this.emailTemplates.find(e => e.type === event['value'])!;
  }



}
